const CaptureImage = 'CaptureImage';
const CaptureDOM = 'CaptureDOM';
const ErrorsJSON = 'ErrorsJSON';
const ComparisonImage = 'ComparisonImage';
const FocusImage = 'FocusImage';

export const CaptureSpecifier = { CaptureImage, CaptureDOM, ErrorsJSON } as const;
export type CaptureSpecifier = (typeof CaptureSpecifier)[keyof typeof CaptureSpecifier];

export const ComparisonSpecifier = { ComparisonImage, FocusImage } as const;
export type ComparisonSpecifier = (typeof ComparisonSpecifier)[keyof typeof ComparisonSpecifier];

export type SnapshotResourceSpecifier = CaptureSpecifier | ComparisonSpecifier;
